import { useQuery } from '@tanstack/react-query';

import { GET_BULK_SESSION_POLICY_QKEY } from '../../legacy/constants/queryKeys';
import SessionService from '../../legacy/services/SessionService';

/**
 * Hook to fetch session policy information for multiple sessions in bulk. Does NOT work for enrolments.
 * @param {Object} params - The parameters object
 * @param {Array<string>} params.sessionIds - Array of session IDs to get policies for
 * @param {boolean} params.enabled - Whether the query should be enabled
 * @returns {Object} React Query result object containing bulk session policy data
 * @example
 * ```tsx
 * const { data: policies, isLoading, error } = useGetBulkSessionPolicy({
 *   sessionIds: ['session-1', 'session-2', 'session-3'],
 *   enabled: true
 * });
 * ```
 */
export const useGetBulkSessionPolicy = ({ sessionIds, enabled }: { sessionIds: Array<string>; enabled: boolean }) => {
  return useQuery({
    queryKey: [GET_BULK_SESSION_POLICY_QKEY, sessionIds],
    queryFn: () => SessionService.getBulkSessionPolicy({ recordIds: sessionIds }),
    retry: 2,
    staleTime: 300000,
    enabled,
    refetchOnWindowFocus: process.env.NODE_ENV !== 'development',
  });
};
